import { z } from 'zod';

import type { PetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';

import { askSchema } from './fields/ask';
import { decisionMakerSchema, serializeDecisionMakers } from './fields/decisionMaker';
import { descriptionSchema } from './fields/description';
import { locationSchema, serializeLocation } from './fields/location';
import { mediaSchema, serializeMedia } from './fields/media';
import { scopeSchema } from './fields/scope';
import { tagsSchema } from './fields/tags';

type ParsedPetitionSchema = z.infer<typeof editFormSchema>;
type Field = keyof PetitionEditPageState['formState'];
// This schema's output should match the `updatePetition` mutation's input after being parsed by zod.
export const editFormSchema = z.object({
	ask: askSchema,
	description: descriptionSchema,
	decisionMakers: decisionMakerSchema.transform(serializeDecisionMakers),
	geoReach: scopeSchema,
	relevantLocation: locationSchema.transform(serializeLocation),
	tags: tagsSchema,
	media: mediaSchema.transform(serializeMedia),
	// add schema + validation for form fields here
});

// serializing the validated schema data to only include changed fields - `dirty = true`
export const serializeParsedPetitionData = (parsedData: ParsedPetitionSchema, state: PetitionEditPageState) => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const keys = Object.keys(parsedData) as readonly Field[];

	return keys.reduce(
		(result, key) => {
			if (state.formState[key].dirty) return { ...result, [key]: parsedData[key] };
			return result;
		},
		{ id: state.id },
	);
};
